import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { toReviewRow, type RawHeldOrder, type ReviewRow } from "../lib/review-vm";

export const REVIEW_QUEUE_KEY = ["manual-review-queue"] as const;

export function useReviewQueue() {
  return useQuery({
    queryKey: REVIEW_QUEUE_KEY,
    queryFn: async (): Promise<ReviewRow[]> => {
      const { data, error } = await apiClient.GET("/v1/orders", {
        params: { query: { exception_only: true } },
      });
      if (error) throw error;
      return (data?.data ?? [])
        .map((o) => toReviewRow(o as unknown as RawHeldOrder))
        .filter((r): r is ReviewRow => r !== null);
    },
  });
}
